module.exports = __webpack_public_path__ + "img/fb_2.f5906343.png";